import { Tabs } from '@jouzen/ecom-components/v3/Tabs';
import { useTranslations } from 'next-intl';
import type { PropsWithChildren } from 'react';

import BackdropBlur from '@/app/components/BackdropBlur';
import Image from '@/app/components/Image';

const TabWrapper = ({ children }: PropsWithChildren) => {
  return (
    <div className="relative flex size-full max-w-[361px] justify-center rounded-md">
      <BackdropBlur
        color={{ sm: 'extra-dark/70', lg: 'extra-dark/70' }}
        variant="card"
      />
      {children}
    </div>
  );
};

const MobileTabs = () => {
  const t = useTranslations();
  return (
    <div data-cy="why-oura-mobile-tabs">
      <Tabs
        style="pill"
        tabs={[
          {
            label: t('june'),
          },
          {
            label: t('july'),
          },
          {
            label: t('august'),
          },
        ]}
        tabPanels={[
          {
            content: (
              <TabWrapper>
                <Image
                  localizedAlt="june_app_image_alt"
                  className="relative rounded-md"
                  localizedSrc="june_app_ui_2025"
                  width={361}
                  height={745}
                  format="png"
                />
              </TabWrapper>
            ),
          },
          {
            content: (
              <TabWrapper>
                <Image
                  localizedAlt="july_app_image_alt"
                  className="relative rounded-md"
                  localizedSrc="july_app_ui_2025"
                  width={361}
                  height={629}
                  format="png"
                />
              </TabWrapper>
            ),
          },
          {
            content: (
              <TabWrapper>
                <Image
                  localizedAlt="august_app_image_alt"
                  className="relative rounded-md"
                  localizedSrc="aug_app_ui_2025"
                  width={361}
                  height={652}
                  format="png"
                />
              </TabWrapper>
            ),
          },
        ]}
      />
    </div>
  );
};

export default MobileTabs;
